import React from 'react'
import { Button } from '../../../components/Button/Button'
import { Modal } from '../../../components/Modal/Modal'

interface DisconnectUsersWarningModalProps {
  show: boolean
  name: string
  isSaving: boolean
  onHide: () => void
  onConfirm: () => void
}

export const DisconnectUsersWarningModal: React.FC<DisconnectUsersWarningModalProps> = ({ show, name, isSaving, onHide, onConfirm }) => (
  <Modal
    show={show}
    onHide={onHide}
    header={`Disconnect everyone from ${name}?`}
    body={
      <div className='d-flex flex-column gap-3'>
        <p className='mb-0'>These changes affect how users authenticate with {name}, so their current connections stop working.</p>
        <div className='d-flex align-items-center zocks-gap-0.75 p-3 rounded-3 zocks-border-color-warning zocks-bg-color-warning zocks-text-gray-900'>
          <i className='bi bi-exclamation-triangle flex-shrink-0' />
          <span>Saving disconnects every user of {name} in your account. Each of them will need to connect again.</span>
        </div>
      </div>
    }
    footer={
      <div className='d-flex gap-3'>
        <Button variant='secondary' onClick={onHide} disabled={isSaving}>
          Cancel
        </Button>
        <Button variant='primary' loading={isSaving} onClick={onConfirm}>
          Save and disconnect users
        </Button>
      </div>
    }
  />
)
